import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"
import InlineNotice from "src/components/InlineNotice"
import Tooltip from "src/components/Tooltip"

const TOOLTIP =
  "Marks the item as non-taxable for tax reporting. It does not change the tax " +
  "collected on a sale."

// Sits with the tax field rather than in a section of its own, so it reads as a
// property of the rate above it. Stored as `taxable`, shown inverted: operators
// think in terms of flagging the exception, not confirming the norm.
const TaxableTag = ({ taxRate, taxRateDisplay }) => {
  const { watch, setValue } = useFormContext()
  const taxable = watch("taxable")
  const nonTaxable = taxable === false

  return (
    <>
      <div className="flex items-center">
        <Form.Checkbox
          name="nonTaxable"
          checked={nonTaxable}
          onChange={(event) => setValue("taxable", !event.target.checked)}
          label="Tag item as non-taxable"
        />
        <Tooltip text={TOOLTIP}>
          <i className="fa-solid fa-circle-info ml-1 inline cursor-pointer" />
        </Tooltip>
      </div>
      {nonTaxable && taxRate > 0 && (
        <div className="pt-2">
          <InlineNotice
            variant="warning"
            icon="fa-circle-exclamation"
            iconStyle="solid"
          >
            This item will still charge {taxRateDisplay} tax. The non-taxable
            tag only affects how it is classified for tax reporting, not what it
            collects.
          </InlineNotice>
        </div>
      )}
    </>
  )
}

TaxableTag.propTypes = {
  // Whatever tax currently applies, in whichever unit the calling form uses —
  // the legacy field is a percent, the itemized helper returns a fraction. Only
  // ever compared against zero, which is why the copy takes a separate
  // already-formatted string rather than trying to format this.
  taxRate: PropTypes.number,
  taxRateDisplay: PropTypes.string,
}

export default TaxableTag
